import { TableUi } from "./Power";

const Adminstration = () => (
  <TableUi
    title="Administration"
    header={false}
    list={[
      "General Administration",
      "Finance & Accounts",
      "Audit",
      "Personnel",
      "Law",
      "Project Planning & Development",
      "Projects through External Funds",
      "Estate Management",
      "Central Workshops",
      "Institute of Urban Management",
    ]}
  />
);

export default Adminstration;
